<div class="result-panel-container">

  <div class="cci-result-panel-form-group">
    <h3>Results</h3>
  </div>

  <div class="cci-result-panel-form-group">
    <div>
      <div *ngIf="!results.length">
        No results found.
      </div>
      <div *ngIf="results.length" class="result-panel-pagination">
        Showing results {{ pagination.startIndex }}-{{ pagination.endIndex }} out of {{ pagination.total }}.
      </div>
    </div>
    <cci-pagination [pagination]="rmsPagination"
                     [totalRecords]="pagination.total"
                     (onPageChanged)="paginationChanged()"
                     (onRecordsPerPageChanged)="paginationChanged()">
    </cci-pagination>
    <table *ngIf="results.length" class="cci-table table table-striped table-bordered">
      <thead class="cci-header">
        <tr>
          <th (click)="headerSortClickEventHandler($event)" *ngFor="let prop of properties()" class="cci-header-data" [attr.data-cci-property-key]="prop" [class.cci-header-sortable]="checkIfHeaderSortable(prop)">
            {{ humanName(prop) }}
            <div *ngIf="checkIfHeaderSortable(prop)" class="cci-header-sortable-icon fa fa-bars"></div>
          </th>
        </tr>
      </thead>
      <tbody class="cci-body">
        <tr class="cci-row" *ngFor="let event of results">
          <td *ngFor="let prop of properties()" class="cci-row-data"><div class="cci-row-data-div cci-tooltip" title="{{safeValue(event, prop)}}">{{safeValue(event, prop)}}</div></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
